import {useCallback} from 'react'
import {useSelector} from 'react-redux'

import {useToggle} from '@vio/core/src/experiments/hooks/useToggle'

import {DEAL_FREEZE_ONBOARDING_EXPERIMENT} from '../components/DealFreezeOnboarding/constants'
import {
  getActiveFrozenBookingCount,
  getIsDealFreezeEnabled
} from '../modules/selector'
import {getUserAlreadyFrozeADealCookie} from '../services/cookies'
import {hasSeenDealFreezeOnboarding} from '../utils/onboarding'

export const useShouldShowDealFreezeOnboarding = (): (() => boolean) => {
  const isDealFreezeEnabled = useSelector(getIsDealFreezeEnabled)
  const activeFrozenBookingCount = useSelector(getActiveFrozenBookingCount)
  const toggle = useToggle()

  return useCallback(() => {
    const userAlreadyFrozeADeal =
      activeFrozenBookingCount > 0 || Boolean(getUserAlreadyFrozeADealCookie())

    if (
      !isDealFreezeEnabled ||
      userAlreadyFrozeADeal ||
      hasSeenDealFreezeOnboarding()
    ) {
      return false
    }

    return toggle(DEAL_FREEZE_ONBOARDING_EXPERIMENT, false, true)
  }, [activeFrozenBookingCount, isDealFreezeEnabled, toggle])
}
